module.exports = __webpack_public_path__ + "img/61.7fc60688.png";